import basePageFields from '@fragments/pages/basePageFields';

import FileFragment from '@fragments/shared/FileFragment';
import TagFragment from '@fragments/pages/TagFragment';
import ImageSummaryFragment from '@fragments/summaries/ImageSummaryFragment';
import PersonSummaryFragment from '@fragments/summaries/PersonSummaryFragment';
import StreamContainedFragment from '@fragments/shared/StreamContainedFragment';
import SyndicationsFragment from '@fragments/shared/SyndicationsFragment';

// PERFORMANCE OPPORTUNITY: the nested parent creates a lot of subqueries and breaks
// default max complexity
export default gql`
    fragment PodcastEpisodeFragment on PodcastEpisode {
        ${basePageFields}
        contributors {
            ...PersonSummaryFragment
        }
        dek
        embedCode
        episodeNumber
        guests {
            ...PersonSummaryFragment
        }
        hero {
            image {
                ...ImageSummaryFragment
            }
        }
        hostOverrides {
            ...PersonSummaryFragment
        }
        parent {
            value {
                ... on Podcast {
                    id
                    title
                    syndications {
                        ...SyndicationsFragment
                    }
                    parent {
                        value {
                            ... on Center {
                                path
                                title
                            }
                        }
                    }
                    podcastNetworks {
                        network
                        subscribeLink {
                            type
                            label
                            url
                        }
                    }
                }
            }
        }
        streamContained {
            ...StreamContainedFragment
        }
        supplementalLinks {
            id
            link {
                type
                label
                url
                reference {
                    path
                    id
                }
            }
        }
        tags {
            ...TagFragment
        }
        pdfResources {
            ...FileFragment
        }
        relatedContent
        syndications {
            ...SyndicationsFragment
        }
    }

    ${FileFragment}
    ${TagFragment}
    ${ImageSummaryFragment}
    ${PersonSummaryFragment}
    ${StreamContainedFragment}
    ${SyndicationsFragment}
`;
